const getClusterIcon = (color: string, size: number) => {
  const svg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'>
      <circle cx='${size / 2}' cy='${size / 2}' r='${size / 2}' fill='${color}' stroke='none'/>
    </svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}


export const MARKER_CLUSTER_STYLES = [
    {
      url: getClusterIcon("#66A3FF", 30),
      height: 28,
      width: 28,
      textColor: "#000",
      textSize: 13,
    },
    {
      url: getClusterIcon("#ffdc00", 40),
      height: 32,
      width: 32,
      textColor: "#000",
      textSize: 13,
    },
    {
      url: getClusterIcon("#d92727", 50),
      height: 36,
      width: 36,
      textColor: "#000",
      textSize: 14,
    },
  ];